<section class="centered-with-padding py-7">
  @if (cabinetBodies(); as cabinetBodies) {
    <div class="grid grid-cols-1 gap-y-3 desk:grid-cols-4 desk:gap-5">
      @for (cabinetBody of cabinetBodies; track index; let index = $index) {
        @if (index === 4) {
          <div class="h-72 desk:hidden">
            <ng-container *ngTemplateOutlet="breathingVideo" />
          </div>
        }
        @if (index === 6) {
          <div class="hidden desk:col-span-2 desk:row-span-2 desk:block">
            <ng-container *ngTemplateOutlet="breathingVideo" />
          </div>
        }
        @if (index === 10) {
          <div class="desk:hidden">
            <ng-container *ngTemplateOutlet="breathingText" />
          </div>
        }
        @if (index === 12) {
          <div class="hidden desk:col-span-2 desk:block">
            <ng-container *ngTemplateOutlet="breathingText" />
          </div>
        }
        <div class="h-[276px] desk:h-[300px]">
          <app-option-card
            (imageClicked)="
              openVisualFullScreenModal(cabinetBody.images[frontsImagesCurrentIndices()[index]!.current]!)
            "
            [image]="cabinetBody.images[frontsImagesCurrentIndices()[index]!.current]!"
            imageCursorType="zoomIn">
            <div
              card-overlay-bottom
              class="flex cursor-default gap-x-2.5 p-2.5"
              (click)="$event.stopPropagation(); $event.preventDefault()">
              <button (click)="updateImageIndex(index, -1)" class="rotate-180">
                <app-svg [height]="13" [width]="20" src="assets/icons/arrow-right.svg" />
              </button>
              <button (click)="updateImageIndex(index, 1)">
                <app-svg
                  [height]="13"
                  [width]="20"
                  [inline]="true"
                  class="text-white"
                  src="assets/icons/arrow-right.svg" />
              </button>
            </div>
            <div card-title-left>{{ cabinetBody.title }}</div>
          </app-option-card>
        </div>
      }
    </div>
  }
</section>

<ng-template #breathingText>
  <div class="flex size-full items-center justify-center py-8 desk:p-6">
    <app-title [title]="{ text: data.breathingText, as: 'span' }" size="h1" />
  </div>
</ng-template>

<ng-template #breathingVideo>
  <div class="desk:mask-blob-ratio-1_035 size-full overflow-hidden rounded-2xl">
    <app-video [autoplay]="true" [video]="data.breathingVideo" />
  </div>
</ng-template>
